export const HELPER_TOOLTIP_MAPPING = {
    // Project Directory
    'Project Directory': 'Directory of projects by every user in your account.',
    'Go to chat': 'Go to chat',
    'Go to Dashboard': 'Go to Dashboard',

    // Create a project
    'Create a Project':
        'Select a rapid solution or build a custom project from scratch',

    // Project Overview / New Project
    'Project Overview': 'General settings for your project',
    'Project Personas': 'Set the tone for your chatbot.',
    'Project URL':
        'Live study link where a code name is required to uniquely identify the study. The code name is usually a single word, short phrase, or acronym that is outside the normal business/domain jargon',
    'Disqualification Control':
        "There's a set of disqualification criteria built into inca's system. These criteria build into a disqualification score based off respondent answers to maintain quality data and a respondent will be terminated if they exceed the disqualification score. Visit our Helpdesk for more details.",
    'Project Language':
        'The survey language(s) used for this study. If multiple languages are selected, the bot will automatically present language options after greeting, and then show the language depending on respondent’s selection for the rest of the survey.',
    Devices:
        'The device type allowed for this study. If participants access the survey link using a device that is not permitted for the study, they will get a message asking them to switch the device.',
    // Question Builder

    // Question Editor
    'Question Builder': 'Add, remove, and edit questions for your study',
    'Question Type': 'Current question type.',
    'Question Label':
        'Label that will display on dashboard. This is not seen by participants.',
    'Question Text':
        'Question to be sent to participants. Each box represents a new message bubble on the chatbot',
    'Allow User Corrections':
        'Allow participants to update their answer after submitting',
    'Skip Practice Question':
        'Skip practice question shown before hand to help demonstrate how to answer question properly',
    'Skip First Stage':
        'It will assume respondent likes all concepts and skip to the head-to-head comparison.',
    'Quality Control':
        'Enable quality controls that will use AI to ensure respondent data is higher quality. More control settings are available on the Conversational Settings tab',
    'Smart Probe':
        'Enable AI to probe on respondent answers that could lead to richer insights. More options such as Research Context, Targets, Trained Models, etc. are available on the Conversational Settings tab',
    'Prompt on Gibberish':
        'Prompt respondent for another answer when gibberish is detected (e.g. jfiwoeht). Please note that some brand names and person names may look like gibberish, please disable this feature when you want to ask for brand/person names.',
    'Text Validation':
        'Require specific format of text, e.g. phone number, email or zip code. (SmartProbe, Gibberish and uninformative answer detection must be disabled to enable this feature)',
    'Prompt on Uninformative Answers':
        'Prompt for more details when the respondent answer is deemed uninformative or generic (e.g. ok, good, don’t know, yes, no, etc.).',
    'Allow Copy and Paste':
        'Allow users to copy and paste text from a different window or source',
    'Answer Reference':
        'With answer reference, the user can customize question wording for each respondent, allowing each of them to have a customized, dynamic, and personal survey experience. The user can reference the answers (including text or image) from a previous question or metadata embedded in the project URL.',
    'Piped Options':
        'Piped options allow the user to pipe answer choices from a previous question',
    Randomize:
        'Choose to show options in a randomized order to the participants (Other and Not applicable will always be anchored at the end).',

    // Video Annotation
    'Min Number of Questions':
        'Min # of comments required from the participants to continue',

    // Image Hotspot Question
    'Show Labels': 'Click to show the label of each area to the participants',

    // Group Question
    'Show All In Order':
        'Display questions to the participants in the order they appear in question builder',
    'Randomize All':
        'Present all of the questions in the group in random order',
    'Randomly Pick Some':
        'Specify the number of questions (out of the total) to have randomly displayed to the participants. If pre-condition(s) are added to the questions, the platform runs pre-condition(s) ahead of random selection',

    // Virtual Question
    'Total Options':
        'The total option number includes options manually created by the users as well as a Not Applicable option added by the system. The Not Applicable option records those with no selection in any manually added options.',

    // Redirect MSG

    'Redirect URL for Completion':
        'The URL to which participants will be routed after completing the survey. The redirect URLs are only available for the live link, and will be overwritten by the 3rd party panel redirects when the panel is included in the live link.',
    'Redirect URL for Termination':
        'The URL to which participants will be routed when they get terminated. The redirect URLs are only available for the live link, and will be overwritten by the 3rd party panel redirects when the panel is included in the live link.',
    'Redirect URL for Quota Full':
        'The URL to which participants will be routed when the quota has been filled. The redirect URLs are only available for the live link, and will be overwritten by the 3rd party panel redirects when the panel is included in the live link.',
    'Redirect URL for Security Disqualification':
        'The URL to which participants will be routed when they exceed the disqualification score (due to bad answer quality). The redirect URLs are only available for the live link, and will be overwritten by the 3rd party panel redirects when the panel is included in the live link.',

    // Question Logic
    'Add Condition':
        'The user may add multiple conditions and when there are multiple conditions added, the relationship between the conditions is OR.',
    'Add Rules':
        'The user may add multiple rules within one condition, and when there are multiple rules added, the relationship between the rules is AND.',
    'Pre-condition':
        'The user can place a pre-condition on a question to make it appear conditionally depending on previous responses when it only applies to particular participants',
    'Post-condition':
        'Post-condition allows the user to send participants to a future point in the survey based on how they answer a question.',

    // Select Questions Modal
    Choice: 'Choice Questions include both single choice question and multiple choice question, which allow participants to select one or several answers from a list.',

    'Rank Order':
        'Rank Order Questions ask participants to rank items or statements in order of preference or importance.',

    Rating: 'Rating Questions ask participants to evaluate a statement on a visual scale of different icons such as stars, hearts, or thumbs, where the number of icons represents the level of agreement, importance, preference or likelihood.',

    Scale: 'Scale Questions are used to measure attitudes by asking participants to give either a positive, neutral or negative response to a statement. They are usually used to gauge agreement, importance, preference or likelihood.',

    Map: 'Map Questions are an interactive choice-based question type that prompts participants to select their location on a map. It is similar to the regular single-select question type, except the answer options are visible on the map.',

    'Open Ended':
        'Open-ended Questions allow participants to type their answers in their own words. We also provide prompts for Gibberish and uninformative answers as well as smart probing to ensure the quality and richness of the responses.',

    'Popup Cards':
        'An improvement on traditional Grid questions, Popup Cards Questions are used when you need to ask several related questions with the same response sets. With a popup card setting, the participants are presented with a series of popup cards of items to be tested, sharing a common set of response options. ',

    'Video Annotation':
        'Video Annotation Questions are used to capture detailed feedback scene by scene. When watching the video, participants can add comments any time when they feel they like what they see, dislike, or are confused by something in the video. ',

    'Image Hotspot':
        'Image Hotspot Questions are used to gather feedback on images. The respondent is presented with an image that has predefined regions to select from. The participants can click on any predefined regions and provide their feedback about this region. ',

    'Tradeoff Ranking':
        'Tradeoff Ranking Questions identify the ideas that are both attractive and competitive, and also explore the reasons behind. It consists of three steps - 1) ask the participants to rate whether they like or dislike the ideas; 2) ask the participants to make head-to-head comparisons among the ideas that they liked; 3) ask follow up open-ended questions as to why they liked or disliked the idea.',

    'Treeman Projective':
        'Treeman is a projective technique. In this technique, stimulus material is shown to the respondent to know about their emotions and feelings related to a particular topic. Participants select the character that best illustrates how they feel. They then provide open ended comments to explain why they feel that way.',

    'Guided Fantasy Projective':
        'Guided Fantasy is a projective technique, asking the respondent to think deeply about the experiences and emotions associated with a visit to ‘Planet Brand’. It allows us to get a deeper understanding of brand perceptions than simply asking people how they feel about a brand. ',

    'Rapid choice':
        'Using behavioural science principles, Rapid Choice allows the users to understand the intuitive, ‘system 1’ associations people have with a brand or stimulus by using time limited response.',

    Multimedia:
        'Multimedia Questions allow adding media content to your survey without asking a question. The media content can be images or video. It can be used, for example, to show stimulus or graphical transition messages.',

    Group: 'Group questions together to help with the logic. There are three ways to show questions in a group - 1) to show all the questions in order, 2) to show all the questions randomly, 3) to randomly pick one or some questions to show',

    'Virtual Question':
        'Virtual question is a question that is hidden from the real survey conversation and the purpose is to help with the survey flow and quota setting, etc.',

    // END OF Question Builder

    // Project Preview
    'Project Preview':
        'Preview your study from start to finish. You can also set custom themes and adjust your bot settings.',
    'Session Timeout': 'Time at which the user does not update the page.',
    'Bot Speed':
        ' How fast the bot pushes the new message. Please set the speed according to your target audience, i.e. how fast they read messages.',
    'Show progress bar':
        ' Enable to show the survey progress to inform the respondent on approximately how much more time it might take to finish the survey',

    Checkout:
        'Order details and payment information. This is the final step before launching your study.',
    'QuickTag Directory': 'Directory of quicktag instances',

    // Account Management
    'Manage Profile': 'Update your profile settings.',
    'Manage Subscription':
        'Change your Account settings. This is where you can also invite new users or update current user access to your account.',
    'Account Name': 'Name under this account.',
    'Account Custom URL': 'Custom name of URL.',

    // Target Audience
    'Target Audience':
        'Audience settings for your project. This is also where you can set custom quotas and screener questions for your study'
};
